var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"flex flex-grow-1 px-2 py-1"},[(_vm.presentation.is_internal_use_only)?_c('div',{staticClass:"font-size-12 font-italic"},[_vm._v("\n    FOR INTERNAL USE ONLY\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }